window.onload = () => {
    activateCart();
    activateAllEmailBtns();
}

const activateAllEmailBtns = () => {
    const emailButton = document.querySelector('footer .contact-email');
    

    const collectAndShowEmail = data => {

        navigator.clipboard.writeText(data)

        alert('The following contact email address has been copied to your clipboard! ' + data + '. Please use it to send your email.');
    }

    emailButton.addEventListener('click', evt => {
        evt.preventDefault();
        const email = emailButton.dataset.email;

        collectAndShowEmail(email);

    })

    const aLinks = document.querySelectorAll('a[href*="mailto:"]');

    aLinks.forEach(emailBtn => {

        emailBtn.addEventListener('click', btn => {
            btn.preventDefault();

            const email = emailBtn.getAttribute('href').split('?')[0].replace(/^mailto:/, '');

            collectAndShowEmail(email);
        });
    })
}

const activateCart = () => {
    const sideNav = document.querySelector('.sidebar-nav');

    // Cart Button
    const cartBtn = document.querySelector('.site-header .main-actions #cart_btn');

    // Mobile Nav Button
    const mobileBtn = document.querySelector('.site-header .mobile-btn');

    cartBtn.addEventListener('click', evt => {
        evt.preventDefault();

        sideNav.classList.remove('nav');
        sideNav.classList.add('cart');

        setTimeout( () => {
            sideNav.classList.add('open');
        }, 100);

        mobileBtn.classList.add('hide');
    })

    mobileBtn.addEventListener('click', evt => {
        evt.preventDefault();

        sideNav.classList.add('nav');
        sideNav.classList.remove('cart');

        setTimeout( () => {
            sideNav.classList.add('open');
        }, 100);

        mobileBtn.classList.add('hide');
    })

    const sidecartDeadArea = document.querySelectorAll('.sidebar-nav .sidebar-dead');

    sidecartDeadArea.forEach(item => {
        item.addEventListener('click', evt => {
            sideNav.classList.remove('open');
            mobileBtn.classList.remove('hide');
        })
    })
}